import React, { useState } from 'react'
import { Link } from 'react-router-dom'

function SideMenuSix({ isSidebarOpen, toggleSidebar }) {
    const [openMenu, setOpenMenu] = useState(null)

    const toggleMenu = (id) => {
        setOpenMenu(openMenu === id ? null : id)
    }

    const close = () => toggleSidebar()

    const scrollToTop = () => {
        // Needed because clicking the same route doesn't trigger React Router scroll.
        try {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        } catch {
            window.scrollTo(0, 0)
        }
    }

    const serviceLinks = [
        { label: 'Medical Billing & Revenue Cycle Management', to: '/medical-billing' },
        { label: 'Cybersecurity Services', to: '/cybersecurity' },
        { label: 'Call Center & Customer Support', to: '/call-center' },
        { label: 'Professional Ebook & Whitepaper Writing', to: '/ebook-whitepaper-writing' },
    ]

    return (
        <div>
            <div id="side-bar" className={`side-bar ${isSidebarOpen ? 'show' : ''}`}>
                <button type="button" className="close-icon-menu" aria-label="Close Menu" onClick={toggleSidebar}>
                    <i className="far fa-times" />
                </button>
                <div className="rts-sidebar-menu-desktop">
                    <Link className="logo-1" to="/" onClick={scrollToTop}>
                        <img className="logo" src="/assets/images/logo/logo-1.svg" alt="" />
                    </Link>
                    <Link className="logo-2" to="/" onClick={scrollToTop}>
                        <img className="logo" src="/assets/images/logo/logo-4.svg" alt="" />
                    </Link>
                    <Link className="logo-3" to="/" onClick={scrollToTop}>
                        <img className="logo" src="/assets/images/logo/techdigit.png" alt="TechDigit Solutions" />
                    </Link>
                    <Link className="logo-4" to="/" onClick={scrollToTop}>
                        <img className="logo" src="/assets/images/logo/logo-5.svg" alt="" />
                    </Link>
                    <div className="body d-none d-xl-block">
                        <p className="disc">
                            TechDigit Solutions — US-focused technology and outsourcing for healthcare, cybersecurity,
                            call centers, and content.
                        </p>
                        <div className="get-in-touch">
                            <div className="h6 title">Get In Touch</div>
                            <div className="wrapper">
                                <div className="single">
                                    <i className="fas fa-phone-alt" />
                                    <a href="tel:+18252516570">+1 (825) 251-6570</a>
                                </div>
                                <div className="single">
                                    <i className="fas fa-envelope" />
                                    <a href="mailto:info@techdigitsolutions.com">info@techdigitsolutions.com</a>
                                </div>
                                <div className="single">
                                    <i className="fas fa-globe" />
                                    <a href="https://www.techdigitsolutions.com" target="_blank" rel="noopener noreferrer">
                                        www.techdigitsolutions.com
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="body-mobile d-block d-xl-none">
                        <nav className="nav-main mainmenu-nav">
                            <ul className="mainmenu metismenu" id="mobile-menu-active">
                                <li className="menu-item">
                                    <Link
                                        className="menu-link"
                                        to="/"
                                        onClick={() => {
                                            scrollToTop()
                                            close()
                                        }}
                                    >
                                        Home
                                    </Link>
                                </li>
                                <li className="menu-item">
                                    <Link
                                        className="menu-link"
                                        to="/about-us"
                                        onClick={() => {
                                            scrollToTop()
                                            close()
                                        }}
                                    >
                                        About
                                    </Link>
                                </li>
                                <li className="menu-item">
                                    <Link
                                        className="menu-link"
                                        to="/industries"
                                        onClick={() => {
                                            scrollToTop()
                                            close()
                                        }}
                                    >
                                        Industries
                                    </Link>
                                </li>
                                <li className="has-droupdown menu-item">
                                    <Link
                                        className={`menu-link ${openMenu === 2 ? 'open' : ''}`}
                                        to="#"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            toggleMenu(2)
                                        }}
                                    >
                                        Services
                                    </Link>
                                    <ul className={`submenu mm-collapse ${openMenu === 2 ? 'active' : ''}`}>
                                        {serviceLinks.map((item, i) => (
                                            <li key={i} className="mobile-menu-link">
                                                <Link
                                                    to={item.to}
                                                    onClick={() => {
                                                        scrollToTop()
                                                        close()
                                                    }}
                                                >
                                                    {item.label}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                                <li className="menu-item">
                                    <Link
                                        className="menu-link"
                                        to="/contactus"
                                        onClick={() => {
                                            scrollToTop()
                                            close()
                                        }}
                                    >
                                        Contact us
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SideMenuSix
